type LoaderState = {
  visible: boolean;
  message: string | undefined;
};

let state: LoaderState = { visible: true, message: "Loading..." };
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function showFullPageLoader(message?: string) {
  state = { visible: true, message };
  emit();
}

export function hideFullPageLoader() {
  state = { visible: false, message: undefined };
  emit();
}

export function subscribeFullPageLoader(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getFullPageLoaderSnapshot(): LoaderState {
  return state;
}
